module.exports = __webpack_public_path__ + "img/ctrl-iswap-stub--.d0b9cf49.svg";